/**
 * File size limits in bytes for various upload types
 */
export const FILE_SIZE_LIMITS = {
    DEFAULT: 5 * 1024 * 1024, // 5MB
    LOGO: 12 * 1024 * 1024, // 12MB
    MAP_NOTE_IMAGE: 12 * 1024 * 1024, // 12MB
};

/**
 * Accepted MIME types for image uploads
 */
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png'];

/**
 * Human-readable file size limit message for rejected file uploads
 */
export const FILE_SIZE_ERROR_MESSAGE = 'Must be JPEG or PNG, and smaller than 12MB';

/**
 * MIME type to file extension mapping
 * Maps MIME types to their corresponding file extensions
 */
export const MIME_TO_EXTENSIONS = {
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
    'image/svg+xml': ['.svg'],
};
